const ListItem = ({children}) => {
  return (
    <p className="iq-home-text iq-home-text-list-item">
        {children}
    </p>
  )
}

export default ListItem